import { clsx } from '../../../ds/clsx';
import { useStableId } from '../../../ds/hooks';
import styles from './calculator.module.css';

export interface SliderFieldProps {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  display: string;
  onChange: (value: number) => void;
  /** Small uppercase label instead of the 13.5 px body label. */
  small?: boolean | undefined;
}

/** Label row + native range input, styled like the prototype's sliders (the year pickers of the customer view). */
export function SliderField({
  label,
  value,
  min,
  max,
  step,
  display,
  onChange,
  small = false,
}: SliderFieldProps) {
  const id = useStableId();
  return (
    <div className={styles.slider}>
      <div className={styles.sliderHead}>
        <label htmlFor={id} className={small ? styles.sliderLabelSmall : styles.sliderLabel}>
          {label}
        </label>
        <output htmlFor={id} className={clsx(styles.sliderValue, small && styles.sliderValueSmall)}>
          {display}
        </output>
      </div>
      <input
        id={id}
        type="range"
        className={styles.range}
        min={min}
        max={max}
        step={step}
        value={Math.min(max, Math.max(min, value))}
        aria-valuetext={display}
        onChange={(event) => onChange(Number(event.target.value))}
      />
    </div>
  );
}
